'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstagramPic = function (_Component) {
  (0, _inherits3.default)(InstagramPic, _Component);

  function InstagramPic(props) {
    (0, _classCallCheck3.default)(this, InstagramPic);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(InstagramPic).call(this, props));

    _this.state = {
      pic: _this.props.pic,
      selected: false
    };
    console.log(_this.state.pic);
    _this.select = _this.select.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(InstagramPic, [{
    key: 'select',
    value: function select() {
      this.setState({ selected: !this.state.selected });
      this.props.onSelect(this.state.pic);
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./InstagramPic.scss');

      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(styles.pic, (0, _defineProperty3.default)({}, styles.selected, this.state.selected)),
        style: { backgroundImage: 'url(' + this.state.pic.url + ')' },
        onClick: this.select });
    }
  }]);
  return InstagramPic;
}(_react.Component);

exports.default = InstagramPic;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InstagramPicker/InstagramPic.js
 ** module id = 1094
 ** module chunks = 0
 **/